import { useMemo } from "react";
import FollowersPresenter from "./FollowersPresenter";
import calcDifference from "@arelia-utils/helpers/calcDifference";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { ComponentProps } from "@arelia-types/widget";
import { useTotalFollowers } from "../../api/social";
import { useSocialFollowerArtistFilter } from "@arelia-hooks/artistAccount";
import { sumBy } from "lodash";

export default function FollowersContainer({ config }: ComponentProps) {
  const requiredConnectionNames = [ConnectionName.facebook, ConnectionName.instagram, ConnectionName.youtube, ConnectionName.tiktok];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const { data = [], isLoading, isError } = useTotalFollowers({ enabled: hasRequiredConnections });
  const filteredData = useSocialFollowerArtistFilter(data);

  const total = useMemo(() => sumBy(filteredData, x => x.total), [filteredData]);
  const changes = useMemo(() => calcDifference(sumBy(data, f => f.total), sumBy(data, f => f.totalLastWeek)), [filteredData]);

  return (
    <FollowersPresenter
      total={total}
      changes={changes}
      loading={isLoading}
      error={isError}
      unconnected={!hasRequiredConnections}
      widgetConfig={config}
    />
  );
}
